import { ref } from 'vue'

// 合集的英文标题只能从接口拿到：MaterialCategory 加载后写入，SEOHeadTags 读取生成页面标题
export const currentMaterialCollection = ref(null)

// 后台新建的分类在前端目录里没有 SEO 名称，同样由 MaterialCategory 写入接口返回的中英文名
export const currentMaterialCategory = ref(null)
